import {createApp} from 'vue'
import router from './router'
import App from './App.vue'
import {VueClipboard} from '@soerenmartius/vue3-clipboard'
import authStore from '@/store/auth'
import {setAuthInHeader} from '@/api'

import './main.scss'
import {createVuetify} from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'
import dayjs from "dayjs";
import global from "@/global";

const customTheme = {
    dark: false,
    colors: {
        "background-1": "#f1f1de",
        "surface-1": "#f1f1de",
        primary: "#3e4827",
        secondary: "#808c24",
        "third": "#bfcc80",
        error: "#f44336",
        info: "#2196F3",
        success: "#4caf50",
        warning: "#fb8c00",
    },
};

const vuetify = createVuetify({
    components,
    directives,
    theme: {
        defaultTheme: "customTheme",
        themes: {
            customTheme,
        },
    },
    icons: {
        defaultSet: 'mdi',
    }
})

const app = createApp(App)

app.use(router)
app.use(dayjs)
app.use(vuetify)
app.use(global)
app.use(VueClipboard)

// 반대편(gilchkin) 로그인 쿠키(YPTOKEN)로 세션 복원 후 마운트
authStore.dispatch('bootstrap').finally(() => {
    // persistedstate 복원은 mutation을 우회하므로 Authorization 헤더를 여기서 재설정
    const t = authStore.state.authInfo && authStore.state.authInfo.token
    if (t) {
        setAuthInHeader(t)
    }
    app.mount('#app')
})
